export const VIEWER_CONFIG = {
  background: 0x0e1116,
  fov: 60,
  near: 0.1,
  far: 5000,
  initialCameraPosition: [20, 20, 20] as const,
  pixelRatioCap: 2,
  edgeColor: 0x10141a,
  // Damping glides the camera on after the mouse stops and eases the start
  // of every move. CAD viewers track the cursor 1:1 instead, so it is off.
  cameraDamping: false,
  // dolly along the pointer ray instead of toward the screen centre
  zoomToCursor: true,
  // how far the orbit pivot may drift from the model, in model radii
  maxPivotDrift: 5,
} as const;

export const IFC_CONFIG = {
  wasmPath: '/wasm/',
  coordinateToOrigin: true,
} as const;

export const MEASURE_CONFIG = {
  color: 0xffb454,
  markerSizePx: 7,
  snapThresholdPx: 14,
} as const;

export const SELECTION_CONFIG = {
  highlightColor: 0x2f81f7,
  highlightIntensity: 0.6,
  hoverIntensity: 0.25,
  clickPixelThreshold: 4,
} as const;
